import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateWorkspaceGoggle } from "api/services/workspace-service";
import { WORKSPACE_GOGGLES_QUERY_KEY } from "hooks/goggles/queryKeys";
import { useAuthContext } from "hooks/useAuthContext";

export const useUpdateWorkspaceGoggle = () => {
    const queryClient = useQueryClient();
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const mutation = useMutation({
        mutationFn: (request: { goggleId: string; displayName: string }): Promise<void> =>
            updateWorkspaceGoggle({ workspaceId, ...request }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WORKSPACE_GOGGLES_QUERY_KEY });
        }
    });

    return {
        updateGoggle: mutation.mutateAsync,
        updatingGoggle: mutation.isPending,
    };
};
